import { t } from "@lingui/macro";
import { FilePdf, SquaresFour } from "@phosphor-icons/react";
import { Button } from "@stylingcv/ui";
import { useResumeStore } from "@/client/stores/resume";

interface PreviewTabProps {
  onDownload: () => void;
  onSwitchToDesign: () => void;
  children: React.ReactNode;
}

export const PreviewTab = ({ onDownload, onSwitchToDesign, children }: PreviewTabProps) => {
  const template = useResumeStore(
    (state) => state.resume.data.metadata.template ?? "modern",
  );

  return (
    <div className="flex flex-1 flex-col overflow-hidden bg-[#faf9f5]">
      {/* Top bar */}
      <div className="flex shrink-0 items-center gap-2 border-b border-black/[0.07] bg-[#faf9f5] px-4 py-2.5">
        <span className="flex-1 text-[11px] font-bold text-[#0A1628]">{t`Preview`}</span>
        <span className="rounded bg-[#f0f0f0] px-2 py-0.5 text-[8px] font-bold uppercase tracking-wide text-[#555]">
          {template}
        </span>
      </div>

      {/* Artboard */}
      <div className="relative flex-1 overflow-hidden">{children}</div>

      {/* Action bar */}
      <div className="flex shrink-0 gap-3 border-t border-black/[0.07] bg-[#faf9f5] px-4 py-2.5">
        <Button
          variant="outline"
          className="flex-1 rounded-xl border-[#e5e2dc] bg-white text-[9px] font-semibold text-[#0A1628] hover:bg-[#f5f3ef]"
          onClick={onSwitchToDesign}
        >
          <SquaresFour className="mr-1.5 size-3.5" />
          {t`Design`}
        </Button>
        <Button
          className="flex-1 rounded-xl bg-[#0A1628] text-[9px] font-bold text-white hover:bg-[#16344c]"
          onClick={onDownload}
        >
          <FilePdf className="mr-1.5 size-3.5" />
          {t`Download PDF`}
        </Button>
      </div>
    </div>
  );
};
